import axios from "axios";
import { DataGrid, DropDownBox } from "devextreme-react";
import {
  Column,
  FilterRow,
  HeaderFilter,
  Scrolling,
  Selection,
} from "devextreme-react/data-grid";
import { useEffect, useState } from "react";

export default function ProjectDropDownBox(props) {
  const { contrNo, setContrNo } = props;

  const [isDropDownOpened, setDropDownOpened] = useState(false);
  const [projectDataSource, setProjectDataSource] = useState(null);
  //   const [selectedRowKeys, setSelectedRowKeys] = useState(null);

  useEffect(async () => {
    async function fetchData() {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/contrReg`
      );

      setProjectDataSource(result.data);
    }

    fetchData();
  }, []);

  const contentRender = () => {
    const onSelectionChanged = (args) => {
      //   setSelectedRowKeys(args.selectedRowKeys);
      setContrNo(args.selectedRowKeys);

      if (args.selectedRowsData.length > 0) {
        setDropDownOpened(false);
      }
    };

    return (
      <DataGrid
        keyExpr={"contrNo"}
        dataSource={projectDataSource}
        remoteOperations={true}
        // height={250}
        // height={700}
        height={"100%"}
        // selectedRowKeys={selectedRowKeys}
        selectedRowKeys={contrNo}
        hoverStateEnabled={true}
        focusedRowEnabled={true}
        // defaultFocusedRowKey={selectedRowKeys ? selectedRowKeys[0] : null}
        defaultFocusedRowKey={contrNo ? contrNo[0] : null}
        onSelectionChanged={onSelectionChanged}
      >
        <Scrolling mode={"virtual"} showScrollbar={"always"} />
        <Selection mode={"single"} />
        <HeaderFilter visible={true} />
        <FilterRow visible={true} applyFilter={"auto"} />

        <Column dataField={"contrNo"} caption={"Contract No."} width={150} />
        <Column dataField={"sprName"} caption={"Sponsor"} />
        <Column dataField={"name"} caption={"Project"} />
      </DataGrid>
    );
  };

  const onOptionChanged = (e) => {
    if (e.name === "opened") {
      setDropDownOpened(e.value);
    }
  };

  return (
    <DropDownBox
      opened={isDropDownOpened}
      dropDownOptions={{
        width: 700,
        //   height: 700,
      }}
      dataSource={projectDataSource}
      //   value={selectedRowKeys ? selectedRowKeys[0] : null}
      value={contrNo ? contrNo[0] : null}
      displayExpr={"contrNo"}
      valueExpr={"contrNo"}
      contentRender={contentRender}
      onOptionChanged={onOptionChanged}
    />
  );
}
